import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { use } from '@frontend/sports/common/core/utils/router';

import { ESportBreadcrumbsResolver } from './esports/esports-breadcrumbs.resolver';
import { MainComponent } from './main/main.component';
import { SportRoute } from './router/multi-route.model';
import { NotAuthenticatedGuard } from './router/not-authenticated-guard.service';
import { SitemapRoutingToken } from './sitemap/sitemap-routing';
import { WidgetSchemaMarkupResolver } from './widget/common/widget-schema-markup.resolver';
import { WidgetResolver } from './widget/common/widget.resolver';
import { WidgetLayoutComponent } from './widget/core/widget-layout.component';

export const INTERNAL_ESPORTS_ROUTES: SportRoute[] = [
    {
        path: '',
        data: {
            headerNavigation: true,
            tag: RouteTag.EsportsLobby,
        },
        component: MainComponent,
        canActivateChild: [NotAuthenticatedGuard],
        runGuardsAndResolvers: 'paramsChange',
        children: [
            {
                path: '',
                component: WidgetLayoutComponent,
                resolve: use(WidgetResolver),
                data: {
                    tag: RouteTag.EsportsLobby,
                    breadcrumbs: ESportBreadcrumbsResolver,
                    schemaMarkup: WidgetSchemaMarkupResolver,
                    sitemap: SitemapRoutingToken.EsportsSitemapResolver,
                },
            },
        ],
    },
];
